// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_g8-0";
export var actionModalContentContainer = "_g8-1";
export var createTagButton = "_g8-2";
export var footerContainer = "_g8-7";
export var fullWidthDivider = "_g8-3";
export var hasCreateTagButton = "_g8-4";
export var noCreateTagButton = "_g8-5";
export var tagsContainer = "_g8-6";
export var tagsModalContentContainer = "_g8-8";